const React = require('react');
const KeyboardDatePickerBase = require('./Base');


module.exports = ({
  helperText,
  ...props
}) => {
  return (<KeyboardDatePickerBase
    {...props}
    InputLabelProps={{
      shrink: true,
    }}
    picker={{
      className: `
w
o50>.MuiInputBase-input.Mui-disabled
(crDefault|bgTransparent)>.MuiInputBase-input.Mui-disabled:h 
(pv19|pt17|hmin56|bxzBB|cF|fw4|ff$2|cr@mouse|crT:f!)>.MuiOutlinedInput-input
ph20>input
(fw4|dn)>(input|textarea):i
o0>.Mui-focused>(input|textarea):i
o100:h>:not[.Mui-focused]>.MuiOutlinedInput-input:i
pv0>textarea.MuiOutlinedInput-input
st-4.5>fieldset
(dn|f15|ov|r8|bgF2:h)>.MuiOutlinedInput-root*2
(bgF2)>.MuiOutlinedInput-root.Mui-disabled*2
(bg04.*-focused!)>.*OutlinedInput-root*3
(b2|bcF.15(>*|:h>*|>.*-focused):not[.*-error])>.*-notchedOutline*2
(f16|ff$2|fw5|x20y19s90|cA3A7AC:not[.*-error]!)>.*InputLabel
cF>[data-shrink=true].*InputLabel:not[.*-error]
cA3A7AC>.MuiIconButton-label
pr8>.*-adornedEnd
cF44336>.MuiFormHelperText-filled
(bgFF7070.05|bcEC4C4C)>.*-error>.*-notchedOutline*2
dN>.MuiFormHelperText-root
f13>.*legendLabelled>span
      `,
    }}
    after={props.error ? (<div className="rlv">
      <div
        className="abs sh20 st1 f12 cEC4C4C fw4 ws"
      >{helperText || 'Date is invalid'}</div>
    </div>) : null}
  />);
};
